import { Show } from "solid-js";
import type { JSX } from "solid-js";
import type { ProjectCard as ProjectCardData } from "~/lib/api";
import { SkillChips } from "~/components/SkillChips";

type Props = {
  project: ProjectCardData;
  onClick?: () => void;
  trailing?: JSX.Element;
};

export function ProjectCard(props: Props) {
  return (
    <div
      class="project-card"
      role={props.onClick ? "button" : undefined}
      tabindex={props.onClick ? 0 : undefined}
      onClick={() => props.onClick?.()}
      onKeyDown={(e) => {
        if (!props.onClick) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          props.onClick();
        }
      }}
    >
      <div
        class={`project-card-cover${props.project.cover_image_url ? "" : " project-card-cover--gradient"}`}
        style={
          props.project.cover_image_url
            ? { "background-image": `url(${props.project.cover_image_url})` }
            : undefined
        }
      >
        <Show when={props.project.is_pinned}>
          <span class="status-chip">Pinned</span>
        </Show>
      </div>
      <div class="project-card-body">
        <strong>{props.project.title}</strong>
        <Show when={props.project.summary}>
          <span>{props.project.summary}</span>
        </Show>
        <SkillChips skills={props.project.skills} limit={3} />
        {props.trailing}
      </div>
    </div>
  );
}
